import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Title from "./Title";
import QuantityBtn from "./QuantityBtn";
import axios from "axios";
import baseURL from "./manager/apiConfig.js";


export default function ProductList() {
  let [productList, setProductList] = useState([]);
  let [searchKeyword, setSearchKeyword] = useState(""); // 新增搜尋關鍵字狀態

  const productsPerRow = 3; // 每行显示的商品数量

  // useEffect hook
  useEffect(() => {
    const getProductList = () => {
      axios.get(`${baseURL}/productCRUD/getall`).then(function (response) {
        console.log(response.data);
        setProductList(response.data);
      });
    };

    getProductList();
  }, []); // <==  Dependency Array

  // 篩選產品列表的函數
  const filteredProducts = productList.filter(product =>
    product.商品名稱.toLowerCase().includes(searchKeyword.toLowerCase())
  );

  return (
    <div style={{ position: 'relative', top: '100px' }}>
      <Title mainTitle="E世代"/>

      {/* 新增搜尋輸入框 */}
      <input
        type="text"
        className="mt-5 form-control container w-25"
        value={searchKeyword}
        onChange={(e) => setSearchKeyword(e.target.value)}
        placeholder="輸入關鍵字搜尋產品..."
      />

      <div className="container justify-content-start">
        {filteredProducts.map((product, index) => (
          <div className="containerItem" key={product.id}>
            <Link to={"/product/" + product.id}>
              <img
                src={process.env.PUBLIC_URL + "/img/" + product.img}
                alt={product.商品名稱}
              />
            </Link>

            <div className="productName">
              {product.商品名稱} - {product.售價}元/件
            </div>

            <QuantityBtn productInfo={product} />
            
            {/* 在每行的最后一个商品后添加clearfix，除非它是最后一个商品 */}
            {(index + 1) % productsPerRow === 0 && index !== filteredProducts.length - 1 && 
              <div className="clearfix"></div>
            }
          </div>
        ))}
      </div>
    </div>
  );
}
